module.exports = __webpack_public_path__ + "information-pig.e998d7129fc74282a8357faa859542a8.png";